import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import BlogComponent from "salad/BlogComponent";
import GrainFooter from "salad/GrainFooter";

export default () => (
    <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
        <MobileHeaderOnly headerBg="#FFFBDC" drawerBg="#FFFBDC" />
        <AnimationRevealPage>
            <BlogComponent />
            <GrainFooter />
        </AnimationRevealPage>
    </div>
);
